export enum EPatientStatus {
  SCHEDULED = 'SCHEDULED',
  CHECKED_IN = 'CHECKED_IN',
  ASSIGN_ROOM = 'ASSIGN_ROOM',
  CHECKED_OUT = 'CHECKED_OUT',
}

export type TGetRoomViewScheduledSurgeriesInput = {
  input: {
    startOfDay: Date
    endOfDay: Date
  }
}

export type TRoomViewReferringPhysician = {
  _id: string
  firstName: string
  lastName: string
  email: string
  mobile?: string
  speciality?: string
}

export type TRoomViewPatient = {
  _id: string
  idMR: string
  firstName: string
  lastName: string
  dateOfBirth?: string
  phoneNumber?: string
  email?: string
  referringPhysician?: TRoomViewReferringPhysician
}

export type TRoomViewProvider = {
  _id: string
  idNPI: string
  firstName: string
  lastName: string
  credentials: string[]
  emailAddresses: string[]
}

export type TRoomViewLocation = {
  department?: string
  room?: string
  bed?: string
}

export type TRoomViewVisit = {
  visitNumber: string
  location: TRoomViewLocation
}

export type TRoomViewProcedureInfo = {
  description?: string
  value?: string
}

export type TRoomViewProcedure = {
  dateTime: Date
  duration: number
  description?: string
  procedureInfo: TRoomViewProcedureInfo[]
}

export type TRoomViewTreeLocation = {
  id: number
  parentLocationId?: number
  order: number
  isAssignableToDepartment: boolean
  isAssignedToProcedure?: boolean
  isInventoryLocation?: boolean
  name: string
  description?: string
  procedures?: TRoomViewProcedure[]
}

export type TRoomViewPatientStatusHistoryInfo = {
  createdAt: Date
  createdBy: string
  period?: number
  formattedPeriod?: string
  room?: TRoomViewTreeLocation
}

export type TRoomViewPatientStatusHistory = {
  status: EPatientStatus
  info: TRoomViewPatientStatusHistoryInfo
}

export type TRoomViewSurgeryStaff = {
  _id: string
  firstName: string
  lastName: string
  roleDescription?: string
  credentials?: string[]
  isAvailable?: boolean
}

export type TRoomViewScheduledSurgery = {
  _id: string
  patient: TRoomViewPatient
  visit: TRoomViewVisit
  procedure: TRoomViewProcedure
  patientStatusHistory: TRoomViewPatientStatusHistory[]
  attendingProvider?: TRoomViewProvider
  surgeryStaff: TRoomViewSurgeryStaff[]
}

export type TGetRoomViewScheduledSurgeriesResponse = {
  getRoomViewScheduledSurgeries: TRoomViewScheduledSurgery[]
}

export type TGetRoomViewRoomsInput = {
  input: {
    startOfDay: Date
    endOfDay: Date
  }
}

export type TRoomViewRoom = {
  id: number
  procedureId?: string
  name: string
  description?: string
}

export type TGetRoomViewRoomsResponse = {
  getRoomViewRooms: TRoomViewRoom[]
}

export type TUpdatePatientStatusVariables = {
  procedureId: string | null
  patientStatus: string | null
  roomId?: number
}

export type TUpdatePatientStatusResponse = {
  updatePatientStatus: {
    message: string
  }
}

export type TGetSurgeryStaffResponse = {
  getSurgeryStaff: TRoomViewSurgeryStaff[]
}

export type TAddRemoveSurgeryStaffResponse = {
  addRemoveSurgeryStaff: {
    success: boolean
  }
}

export type TAddRemoveSurgeryStaffInput = {
  input: {
    surgeryId: string
    surgeryStaffIds: string[]
  }
}

export type TRoomViewSettings = {
  showProcedureName: boolean
  showStaffAssignment: boolean
  showExpectedEndTime: boolean
}

export type TUpdateAppConfigInput = {
  input: {
    roomViewSettings: Partial<TRoomViewSettings>
  }
}

export type TUpdateAppConfigResponse = {
  updateAppConfig: {
    success: boolean
  }
}
